/**
 * Import Dependencies
 */
import { combineReducers } from "redux";

/**
 * Import Reducers
 * All Reducers used in the App must be declared here!
 */
import ThemeReducer from "./Theme/reducer";
import SetConfigReducer from "./InitialConfig/reducer";
import UserProfileRecducer from "./UserProfile/reducer";
import CryAnalyserReducer from "./CryAnalyser/reducer";
import AssessmentReducer from "./Assessment/reducer";
import ForYouReducer from "./ForYou/reducer";
import ExpertsReducer from "./Experts/reducer";
import QARAReducer from "./QARA/reducer";
import SubscriptionReducer from "./Subscription/reducer";

/**
 * Combine the Reducers
 */
const reducers = combineReducers({
  assessment: AssessmentReducer,
  userProfile: UserProfileRecducer,
  cryAnalyser: CryAnalyserReducer,
  theme: ThemeReducer,
  initialConfig: SetConfigReducer,
  forYou: ForYouReducer,
  experts: ExpertsReducer,
  qara: QARAReducer,
  subscription: SubscriptionReducer,
});

/**
 * Export the combined Reducers
 */
export default reducers;
